export class LoadMessages {
  static readonly type = '[Messages] Load Messages';
}

export class LoadConversation {
  static readonly type = '[Messages] Load Conversation';
  constructor(public conversationId: string) {}
}

export interface MessageFilters {
  senderId?: string;
  receiverId?: string;
  bookingId?: string;
  isRead?: boolean;
  type?: string;
}

export class SendMessage {
  static readonly type = '[Messages] Send Message';
  constructor(
    public payload: {
      conversationId: string;
      text: string;
      senderId: string;
      receiverId: string;
      content: string;
      bookingId?: string;
    },
  ) {}
}

export class MarkMessageAsRead {
  static readonly type = '[Messages] Mark Message As Read';
  constructor(public messageId: string) {}
}

export class MarkConversationAsRead {
  static readonly type = '[Messages] Mark Conversation As Read';
  constructor(public conversationId: string) {}
}

export class FilterMessages {
  static readonly type = '[Messages] Filter Messages';
  constructor(public filters: MessageFilters) {}
}

export class SearchMessages {
  static readonly type = '[Messages] Search Messages';
  constructor(public query: string) {}
}

export class SetMessagesPage {
  static readonly type = '[Messages] Set Messages Page';
  constructor(public page: number) {}
}

export class SetMessagesLoading {
  static readonly type = '[Messages] Set Messages Loading';
  constructor(public loading: boolean) {}
}

export class SetMessagesError {
  static readonly type = '[Messages] Set Messages Error';
  constructor(public error: string | null) {}
}
